import { ColDef } from '@ag-grid-community/core'
import { diffDateFormatter } from '../../../../helpers/formatting'
import { simpleSum, sumDate } from '../../../../helpers/gridFunctions'

export const USER_NAME = 'userName'
export const CUSTOMER_NAME = 'customerName'
export const BROKER = 'broker'
export const MAKER_ORDERS = 'makerOrderCount'
export const TAKER_ORDERS = 'takerOrderCount'
export const TRADE_COUNT = 'tradeCount'
export const TRADE_VOLUME = 'tradeVolume'
export const MINUTES_LOGGED_IN = 'minutesLoggedIn'
export const LAST_LOGON_TIME = 'lastLogon'
export const USING_OPENFIN = 'usingOpenfin'
export const WEBSERVER = 'webserver'

export const customizableColumns: ColDef[] = [
  {
    colId: USER_NAME,
    field: USER_NAME,
    headerName: 'User',
    sortable: true,
    filter: 'agTextColumnFilter'
  },
  {
    colId: CUSTOMER_NAME,
    field: CUSTOMER_NAME,
    width: 200,
    suppressAutoSize: true,
    sortable: true,
    headerName: 'Customer',
    filter: 'agTextColumnFilter'
  },
  {
    colId: BROKER,
    field: BROKER,
    headerName: 'Broker',
    filter: 'agTextColumnFilter'
  },
  {
    colId: MAKER_ORDERS,
    field: MAKER_ORDERS,
    filter: 'agNumberColumnFilter',
    headerName: 'Maker Orders',
    aggFunc: simpleSum
  },
  {
    colId: TAKER_ORDERS,
    field: TAKER_ORDERS,
    headerName: 'Aggress Orders',
    filter: 'agNumberColumnFilter',
    aggFunc: simpleSum
  },
  {
    colId: TRADE_COUNT,
    field: TRADE_COUNT,
    headerName: 'Trade Count',
    filter: 'agNumberColumnFilter',
    aggFunc: simpleSum
  },
  {
    colId: TRADE_VOLUME,
    field: TRADE_VOLUME,
    headerName: 'Trade Volume',
    filter: 'agNumberColumnFilter',
    aggFunc: simpleSum
  },
  {
    colId: MINUTES_LOGGED_IN,
    field: MINUTES_LOGGED_IN,
    headerName: 'Minutes logged in',
    filter: 'agNumberColumnFilter',
    aggFunc: simpleSum
  },
  {
    colId: LAST_LOGON_TIME,
    field: LAST_LOGON_TIME,
    headerName: 'Last logon time',
    valueFormatter: diffDateFormatter,
    filter: 'agDateColumnFilter',
    aggFunc: sumDate
  },
  {
    colId: USING_OPENFIN,
    field: USING_OPENFIN,
    headerName: 'Using Openfin'
  },
  {
    colId: WEBSERVER,
    field: WEBSERVER,
    headerName: 'Webserver'
  }
]

export const columnDefinitions: ColDef[] = [...customizableColumns]
